import { render, staticRenderFns } from "./WikiHomeManager.vue?vue&type=template&id=c8be9ff6&"
import script from "./WikiHomeManager.vue?vue&type=script&lang=js&"
export * from "./WikiHomeManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports